// extracted by mini-css-extract-plugin
export var cardHeader = "_t2-0";
export var reorderHandle = "_t2-3";
export var titleArea = "_t2-1";
export var titleAreaWithHandle = "_t2-2";